// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__dS6gT","input__container":"TextInput_input__container__CpnwN"};